import {
  SubTask,
  Task,
} from 'packages/atlassian-analytics/src/constants/ActionSubjectId';
import { SourceType } from 'packages/atlassian-analytics/src/constants/Source';
import { Analytics } from '../AnalyticsClient';

/**
 * Returns a callback that automatically intercepts success/failure callbacks
 * and finishes tracing a given task.
 *
 * @param {Task} taskName (required)
 * @param {SubTask} [subTask] (optional)
 * @param {string} traceId (required) Trace id, returned by Analytics.startTask
 * @param {SourceType} source (required) Screen that task occurred
 * @param {Function} [next] (optional) If defined will invoke another (err, result: T) callback,
 * usually used for additional tracking, before task is marked as successful
 * @example
 * // Typically used when interacting with Backbone models
 * this.model.close(traceId, withTracing({ traceId, task: 'edit-card', subTask: 'closed' }))
 */
export function tracingCallback<T>(
  {
    taskName,
    subTask,
    traceId,
    source,
  }: {
    taskName: Task;
    subTask?: SubTask;
    traceId: string;
    source: SourceType;
  },
  next?: (err: object | null, result: T) => void,
) {
  return (err: object | null, result: T) => {
    if (err) {
      Analytics.taskFailed({
        taskName,
        subTask,
        traceId,
        source,
      });

      throw err;
    } else {
      if (next) {
        next(err, result);
      }
      Analytics.taskSucceeded({
        taskName,
        subTask,
        traceId,
        source,
      });
    }
  };
}
